require('./bootstrap');

require('alpinejs');

var isSideSocialsActive = false

function toggleSidebarSocials(navbarTop) {
    const sidebarSocialsEl = $("#sidebar-socials")
    if (navbarTop <= 0) {
        if (isSideSocialsActive)
            return

        sidebarSocialsEl.fadeIn()
        isSideSocialsActive = true
    } else {
        if (!isSideSocialsActive)
            return

        sidebarSocialsEl.fadeOut()
        isSideSocialsActive = false
    }
}

window.pinImageWhileScrollEffect = function (controller, textContainerSelector, imageContainerSelector, triggerElement) {
    var imageContainerPair = document.querySelector(textContainerSelector);
    var image = document.querySelector(imageContainerSelector);

    // Calculate the duration for the ScrollMagic scene
    var imageContainerHeight = imageContainerPair.offsetHeight;
    var imageHeight = image.offsetHeight;
    var sceneDuration = imageContainerHeight - imageHeight;

    if (sceneDuration <= 0)
        return

    // Create a new ScrollMagic scene
    new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: '0.09',
        duration: sceneDuration
    })
        .setPin(triggerElement)
        .addTo(controller);
}

// Avatar card
$(".avatar-info").click(function () {
    var refId = $(this).data("id")
    var destinationElement = $("#" + refId)

    // Toggle all cards back when current card is not active
    if (!destinationElement.hasClass("animated-card-show-info")) {
        $(".avatar-info").children().attr('class', 'bi bi-info-lg')
        $(".animated-card-show-info").removeClass("animated-card-show-info")
    }

    destinationElement.toggleClass("animated-card-show-info")
    const backCard = destinationElement.find('.back')
    backCard.toggleClass("pe-none")
    // Change button icon
    var iconName = destinationElement.hasClass("animated-card-show-info") ? 'bi bi-x-lg' : 'bi bi-info-lg'
    $(this).children().attr('class', iconName)
})

// Scroll effect for navbar background while scrolling
window.addEventListener('scroll', function (e) {
    const navbarEl = document.querySelector("#navbar")
    let navbarTop = navbarEl.getBoundingClientRect().top
    var screenWidth = window.outerWidth;

    if (screenWidth >= 576)
        toggleSidebarSocials(navbarTop)

    if (!$("body").data('theme'))
        return
    // Glass effect for the header in the dark mode only
    const topperEl = document.querySelector("#navbar-topper")

    if (navbarTop <= 0) {
        navbarEl.classList.add('glass--show')
        navbarEl.classList.remove('glass--hide')
        topperEl.classList.add('glass--show')
        topperEl.classList.remove('glass--hide')
    } else {
        navbarEl.classList.remove('glass--show')
        navbarEl.classList.add('glass--hide')
        topperEl.classList.remove('glass--show')
        topperEl.classList.add('glass--hide')
    }
});

window.scrollToTargetAdjustedFromDropdown = function (dropdownClass, targetId) {
    // Close dropdown menu

    // Scroll to target
    const element = document.getElementById(targetId);
    const offset = 45;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
}


const mainOffcanvas = new bootstrap.Offcanvas('#offcanvasExample')
$(".animated-link").on("click", function (e) {
    e.preventDefault();
    var w = window.outerWidth;
    var offset = w < 992 ? 100 : 400;

    if (w < 992) {
        mainOffcanvas.hide()
        $(".btn-custom-offcanvas-close").each((key, value) => closeOffcanvas($(value)));
    } else {
        $(".dropdown-mega #service-dropdown").dropdown("toggle")
    }

    const toId = $(this).attr("href");
    $("html, body").animate({
        scrollTop: $(toId).offset().top - offset
    });
});

// Custom offcanvas
// Open projects offcanvas
$("#offcanvasOpenProjects, #offcanvasOpenServices, #offcanvasOpenCompany").click(function (e) {
    const offcanvasId = $(this).data("offcanvas-id")
    $(`#${offcanvasId}`).addClass("show")
    $(`#${offcanvasId}`).css("visibility", "visible")

    // Add pointer events to backdrop to prevent clicking on backdrop while the second offcanvas is opened
    $("header .modal-backdrop.fade.show").css("pointer-events", "none")
})

function closeOffcanvas(el) {
    const offcanvasId = el.data("offcanvas-id")
    $(`#${offcanvasId}`).removeClass("show")
    setTimeout(function () {
        $(`#${offcanvasId}`).css("visibility", "hidden")
        $("header .modal-backdrop.fade.show").css("pointer-events", "visible")
    }, 300)
}

$(".btn-custom-offcanvas-close").click(function () {
    closeOffcanvas($(this))
})

// Audit overlay close/open
$(".audit-overlay-close").click(function () {
    const overlayId = $(this).data("overlay-id")

    $(`#${overlayId}`).addClass("hide")
    $(`#${overlayId}`).removeClass("show")
    setTimeout(function () {
        $(`#${overlayId}`).css("visibility", "hidden")
    }, 300)
})

$(".audit-overlay-open").click(function () {
    const overlayId = $(this).data("overlay-id")

    $(`#${overlayId}`).removeClass("hide")
    $(`#${overlayId}`).addClass("show")
    $(`#${overlayId}`).css("visibility", "visible")
})

window.twitterWidget = function () {
    return {
        _twitterContainerId: 'twitter-container',

        init() {
            this._createNewTwitterWidget()
        },
        _emptyingBodyOf(id) {
            document.getElementById(id).innerHTML = "";
        },
        _getTwitterOptions() {
            let options = {
                lang: 'en',
                height: '600',
                chrome: 'noborders transparent noscrollbar',
                tweetLimit: 3,
                theme: 'dark'
            }

            return options
        },
        _createNewTwitterWidget() {
            try {
                window.twttr.widgets.createTimeline(
                    {
                        sourceType: "profile",
                        screenName: "SolidProof_io",
                    },
                    document.getElementById(this._twitterContainerId),
                    this._getTwitterOptions()
                );
            } catch (error) {

            }
        }
    }
}

window.darkLightMode = function () {
    return {
        isDarkActive: false,
        _localStorageName: "solidproofDarkModeStatus",
        _twitterContainerId: 'twitter-container',

        init() {
            this.isDarkActive = true
            this._setDataTheme()
            this._createNewTwitterWidget()
        },

        handleChange() {
            if (this.isDarkActive)
                localStorage.setItem(this._localStorageName, this.isDarkActive)
            else
                localStorage.removeItem(this._localStorageName)

            this._setDataTheme()
            this._emptyingBodyOf(this._twitterContainerId)
            this._createNewTwitterWidget()

        },
        _setDataTheme() {
            if (this.isDarkActive)
                document.body.setAttribute("data-theme", "dark")
            else
                document.body.removeAttribute("data-theme")
        },
        _emptyingBodyOf(id) {
            document.getElementById(id).innerHTML = "";
        },
        _getTwitterOptions() {
            let options = {
                lang: 'en',
                height: '600',
                chrome: 'noborders transparent noscrollbar',
                tweetLimit: 3,
            }
            if (this.isDarkActive)
                options = {
                    ...options,
                    theme: 'dark'
                }

            return options
        },
        _createNewTwitterWidget() {
            try {

                window.twttr.widgets.createTimeline(
                    {
                        sourceType: "profile",
                        screenName: "SolidProof_io",
                    },
                    document.getElementById(this._twitterContainerId),
                    this._getTwitterOptions()
                );
            } catch (error) {

            }
        }
    }
}
